import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { theme } from '../styles/theme';
import Button from './ui/Button';
import { FaCheckCircle } from 'react-icons/fa';

const SubscriptionSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { refreshSubscription } = useAuth();

  useEffect(() => {
    // Refresh subscription data to get the latest info
    refreshSubscription();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '80vh',
      padding: '24px'
    }}>
      <div style={{
        maxWidth: '600px',
        textAlign: 'center',
        backgroundColor: theme.colors.surface,
        padding: '48px',
        borderRadius: '12px',
        border: `1px solid ${theme.colors.border}`
      }}>
        {/* Success Icon */}
        <div style={{
          display: 'inline-flex',
          padding: '24px',
          backgroundColor: '#D1FAE5',
          borderRadius: '50%',
          marginBottom: '24px'
        }}>
          <div style={{ color: '#059669' }}>
            {FaCheckCircle({ size: 64 })}
          </div>
        </div>

        {/* Title */}
        <h1 style={{
          fontSize: theme.typography.sizes['3xl'],
          fontWeight: theme.typography.weights.bold,
          color: theme.colors.text.primary,
          marginBottom: '16px'
        }}>
          Welcome to Pro!
        </h1>

        {/* Message */}
        <p style={{
          fontSize: theme.typography.sizes.lg,
          color: theme.colors.text.secondary,
          marginBottom: '32px',
          lineHeight: 1.6
        }}>
          Your subscription has been activated successfully. You now have access to unlimited trackable links and all Pro features!
        </p>

        {/* CTA Buttons */}
        <div style={{
          display: 'flex',
          gap: '16px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <Button
            variant="primary"
            size="lg"
            onClick={() => navigate('/dashboard')}
          >
            Go to Dashboard
          </Button>
          <Button
            variant="secondary"
            size="lg"
            onClick={() => navigate('/subscription')}
          >
            View Subscription
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
